import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function DirectTax() {
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab =
    location.pathname === "/direct-tax"
      ? "direct"
      : location.pathname === "/indirect-tax"
      ? "indirect"
      : "taxation";

  const handleTabClick = (path) => navigate(path);

  return (
    <>
      <Header />

      {/* ==== HERO ==== */}
      <section
        className="about-hero directtax-hero"
        style={{ backgroundImage: "url('/assets/img/Achievements.jpg')" }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text fade-in-up">
          <h1>Direct Tax (Income Tax)</h1>
          <p>Expert guidance and compliance support for income tax matters.</p>
        </div>
      </section>

      {/* ==== TABS ==== */}
      <div className="tax-tabs">
        <button
          className={activeTab === "taxation" ? "active" : ""}
          onClick={() => handleTabClick("/taxation-compliance")}
        >
          Taxation & Compliance
        </button>
        <button
          className={activeTab === "direct" ? "active" : ""}
          onClick={() => handleTabClick("/direct-tax")}
        >
          Direct Tax (Income Tax)
        </button>
        <button
          className={activeTab === "indirect" ? "active" : ""}
          onClick={() => handleTabClick("/indirect-tax")}
        >
          Indirect Tax (GST)
        </button>
      </div>

      {/* ==== PROCESS ==== */}
      <section className="audit-process container my-5">
        <h2>Our Direct Tax Process</h2>
        <div className="process-wrapper">
          <img
            src="/assets/img/directtax.png"
            alt="Direct Tax Process"
            className="audit-process-img"
          />
        </div>
      </section>

      {/* ==== SLIDER SECTION ==== */}
      <section className="container my-5 directtax-slider-wrap">
        {/* LEFT ARROW */}
        <button className="slider-arrow slider-prev">‹</button>

        {/* RIGHT ARROW */}
        <button className="slider-arrow slider-next">›</button>

        <Swiper
          modules={[Navigation, Pagination]}
          navigation={{
            prevEl: ".slider-prev",
            nextEl: ".slider-next",
          }}
          pagination={{ clickable: true }}
          spaceBetween={30}
        >
          {/* ===== SLIDE 1 ===== */} 
          <SwiperSlide>
            <div className="bf-main">
              <div className="bf-card">
                <h3>📑 Income Tax Return Filing</h3>
                <p>
                  Accurate, timely ITR filing for individuals, firms, LLPs, and
                  companies with comprehensive documentation and post-filing
                  support.
                </p>
                <ul>
                  <li>Documentation checklist</li>
                  <li>Computation & disclosures</li>
                  <li>Post-filing support</li>
                  <li>E-filing assistance</li>
                </ul>
              </div>

              <div className="bf-card">
                <h3>📆 Advance Tax & Interest Optimization</h3>
                <p>
                  Strategic advance tax planning to reduce interest exposure and
                  improve cash-flow control.
                </p>
                <ul>
                  <li>Installment planning</li>
                  <li>Interest impact review</li>
                  <li>Periodic monitoring</li>
                </ul>
              </div>

              <div className="bf-card">
                <h3>📊 Tax Planning & Advisory</h3>
                <p>
                  Structuring income, investments, and transactions for
                  compliant tax efficiency.
                </p>
                <ul>
                  <li>Income structuring</li>
                  <li>Tax-saving roadmap</li>
                  <li>Transaction advisory</li>
                </ul>
              </div>

              <div className="bf-card">
                <h3>🧾 TDS/TCS & Withholding</h3>
                <p>
                  From deduction to deposit, returns, reconciliation, and
                  rectifications.
                </p>
                <ul>
                  <li>Quarterly statements</li>
                  <li>Reconciliation & corrections</li>
                  <li>Compliance advisory</li>
                </ul>
              </div>

              <div className="bf-card">
                <h3>🔍 Tax Audit & Reporting</h3>
                <p>
                  Tax audit support including Form 3CD reporting and
                  documentation readiness.
                </p>
                <ul>
                  <li>Audit planning</li>
                  <li>Form 3CD reporting</li>
                  <li>Working paper support</li>
                </ul>
              </div>

              <div className="bf-card">
                <h3>🏢 Corporate Tax Management</h3>
                <p>
                  Corporate tax computation, MAT/AMT, deferred tax, and
                  compliance management.
                </p>
                <ul>
                  <li>Tax computation</li>
                  <li>Advance tax planning</li>
                  <li>Deferred tax analysis</li>
                </ul>
              </div>
            </div>
          </SwiperSlide>

          {/* ===== SLIDE 2 ===== */}
          <SwiperSlide>
            <div className="bf-main">
              <div className="bf-card">
                <h3>⚖️ Scrutiny & Assessments</h3>
                <p>
                  Expert representation for scrutiny, reassessment, and
                  appeals.
                </p>
                <ul>
                  <li>Notices & submissions</li>
                  <li>CIT(A) / ITAT support</li>
                  <li>Dispute resolution</li>
                </ul>
              </div>

              <div className="bf-card">
                <h3>🌍 International Tax & DTAA</h3>
                <p>
                  Cross-border transaction advisory and DTAA implications.
                </p>
                <ul>
                  <li>DTAA analysis</li>
                  <li>PE exposure review</li>
                  <li>Cross-border structuring</li>
                </ul>
              </div>

              <div className="bf-card">
                <h3>🔗 Transfer Pricing</h3>
                <p>
                  Documentation and benchmarking for related-party
                  transactions.
                </p>
                <ul>
                  <li>Benchmarking studies</li>
                  <li>TP documentation</li>
                  <li>Filing support</li>
                </ul>
              </div>

              <div className="bf-card">
                <h3>🌐 Form 15CA / 15CB</h3>
                <p>
                  Foreign remittance certification and compliance support.
                </p>
                <ul>
                  <li>Remittance review</li>
                  <li>Withholding analysis</li>
                  <li>Certificate assistance</li>
                </ul>
              </div>

              <div className="bf-card">
                <h3>👔 Expatriate Taxation</h3>
                <p>
                  Tax residency analysis and compliance for expatriates
                  working in India.
                </p>
                <ul>
                  <li>Residential status determination</li>
                  <li>Salary structuring</li>
                  <li>Return filing support</li>
                </ul>
              </div>

              <div className="bf-card">
                <h3>🛡️ Tax Due Diligence</h3>
                <p>
                  Comprehensive tax risk review for M&A and strategic
                  investments.
                </p>
                <ul>
                  <li>Risk identification</li>
                  <li>Exposure mapping</li>
                  <li>Deal support</li>
                </ul>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>

      <Footer />
    </>
  );
}
